import React, { Component } from "react";
import DateTimeRenderer from "../cell-renderer/DateTimeRenderer";
import UserDisplay from "../UserDisplay";
import i18next from "i18next";

class TrackSearchHistory extends Component {
    constructor(props) {
      super();
      this.state = {
      };
    }

    getHistView(t){
        const { getStatus } = this.props;
        return <>
          <>
            { t.changedFields.length > 0 && (
              <ul>
                {t.changedFields.map(k=>{
                  switch(k){
                    case 'clearancestatus':
                        return <li>{t?.track?.trackDetails?.trackTitle} - {i18next.t(`history.fields.${k}`)} to 
                        { getStatus(t.track[k])?.id == 'notfound' ? (
                          <span> Clear Me</span>
                        ):(
                          <span
                            class="clearanceValueLabel"
                            style={{
                              color: getStatus(t.track[k]).color,
                            }}
                          >
                          <div
                            style={{
                              background: getStatus(t.track[k]).color,
                            }}
                          ></div>
                            {getStatus(t.track[k]).name}
                          </span>
                        )}
                        <span>{t?.track?.adminOverriddenWithNotes}</span></li>
                    default:
                      if(t.track[k] && t.track[k].length>0){
                        return <li>{t?.track?.trackDetails?.trackTitle} - {i18next.t(`history.fields.${k}`)} to { Array.isArray(t.track[k])?(()=>"\r\n"+t.track[k].join(", "))():t.track[k] } {t?.track?.adminOverriddenWithNotes}</li>
                      }
                      else{
                        return "";
                      }
                  }
                })}
              </ul>
            ) }
          </>
        </>
      }
  
    render() {
      const { classes, data } = this.props;
  
      return (
        <>
             { data.map(d=>{
                return <>
                
            
                <div className={classes.historyItem}>
                    <p className={classes.userName}>
                        <UserDisplay userId={d.by} />
                    </p>
                    <p className={classes.changedDate}>
                        <DateTimeRenderer data={d.at} />
                    </p>
                    <p>On Form : {d.clearanceFormName}</p>
                    { d.track.adminOverridden ? (<p className={classes.actionName}>Track {i18next.t(`history.keys.override`)}</p>) : (<p className={classes.actionName}>Track {d.actionType == "create"?"Added":i18next.t(`history.keys.${d.actionType}`)}</p>) }
                    
                    <div className={classes.objectName}>
                        {this.getHistView(d)}
                    </div>
                    
                    </div>
                  
                   
                    </>
                }) }
        </>
      );
    }
  }
  
export default TrackSearchHistory;